// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"521":"errors-404","795":"error-403","852":"errors-500","945":"dashboard","954":"configurations","966":"login"}[chunkId] || chunkId) + "." + {"521":"4329abc4","795":"8717c8ca","852":"d4fe47a4","905":"e2a2db9a","945":"a52bdb29","954":"caad5177","966":"b65a6fde"}[chunkId] + ".css";
};